import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from './locales/en/common.json';
import enNavigation from './locales/en/navigation.json';
import enDashboard from './locales/en/dashboard.json';
import enErrors from './locales/en/errors.json';
import enLanding from './locales/en/landing.json';
import enUser from './locales/en/user.json';
import enPrivacySecurity from './locales/en/privacySecurity.json';
import enApiIntegration from './locales/en/apiIntegration.json';
import enAuditLogs from './locales/en/auditLogs.json';
import enVocabularyManagement from './locales/en/vocabularyManagement.json';
import enGeneralVocabularyManagement from './locales/en/generalVocabularyManagement.json';
import enReadingManagement from './locales/en/readingManagement.json';
import enWritingDictationManagement from './locales/en/writingDictationManagement.json';
import enExamManagement from './locales/en/examManagement.json';
import enCourseLibrary from './locales/en/courseLibrary.json';
import enEspCourses from './locales/en/espCourses.json';
import enLiveLearning from './locales/en/liveLearning.json';
import enLiveCommunication from './locales/en/liveCommunication.json';
import enTeacher from './locales/en/teacher.json';
import enParent from './locales/en/parent.json';
import enResourcesManagement from './locales/en/resourcesManagement.json';

import arCommon from './locales/ar/common.json';
import arNavigation from './locales/ar/navigation.json';
import arDashboard from './locales/ar/dashboard.json';
import arErrors from './locales/ar/errors.json';
import arLanding from './locales/ar/landing.json';
import arUser from './locales/ar/user.json';
import arPrivacySecurity from './locales/ar/privacySecurity.json';
import arApiIntegration from './locales/ar/apiIntegration.json';
import arAuditLogs from './locales/ar/auditLogs.json';
import arVocabularyManagement from './locales/ar/vocabularyManagement.json';
import arGeneralVocabularyManagement from './locales/ar/generalVocabularyManagement.json';
import arReadingManagement from './locales/ar/readingManagement.json';
import arWritingDictationManagement from './locales/ar/writingDictationManagement.json';
import arExamManagement from './locales/ar/examManagement.json';
import arCourseLibrary from './locales/ar/courseLibrary.json';
import arEspCourses from './locales/ar/espCourses.json';
import arLiveLearning from './locales/ar/liveLearning.json';
import arLiveCommunication from './locales/ar/liveCommunication.json';
import arTeacher from './locales/ar/teacher.json';
import arParent from './locales/ar/parent.json';

import frCommon from './locales/fr/common.json';
import frNavigation from './locales/fr/navigation.json';
import frDashboard from './locales/fr/dashboard.json';
import frErrors from './locales/fr/errors.json';
import frLanding from './locales/fr/landing.json';
import frUser from './locales/fr/user.json';
import frPrivacySecurity from './locales/fr/privacySecurity.json';
import frApiIntegration from './locales/fr/apiIntegration.json';
import frAuditLogs from './locales/fr/auditLogs.json';
import frVocabularyManagement from './locales/fr/vocabularyManagement.json';
import frGeneralVocabularyManagement from './locales/fr/generalVocabularyManagement.json';
import frReadingManagement from './locales/fr/readingManagement.json';
import frWritingDictationManagement from './locales/fr/writingDictationManagement.json';
import frExamManagement from './locales/fr/examManagement.json';
import frCourseLibrary from './locales/fr/courseLibrary.json';
import frEspCourses from './locales/fr/espCourses.json';
import frLiveLearning from './locales/fr/liveLearning.json';
import frLiveCommunication from './locales/fr/liveCommunication.json';
import frTeacher from './locales/fr/teacher.json';
import frParent from './locales/fr/parent.json';

// Import utilities
import { setDirection } from '../utils/dirManager';
import { loadFontForLanguage } from '../utils/fontLoader';
import logger from '../utils/logger';

const resources = {
  en: {
    common: enCommon,
    navigation: enNavigation,
    dashboard: enDashboard,
    errors: enErrors,
    landing: enLanding,
    user: enUser,
    privacySecurity: enPrivacySecurity,
    apiIntegration: enApiIntegration,
    auditLogs: enAuditLogs,
    vocabularyManagement: enVocabularyManagement,
    generalVocabularyManagement: enGeneralVocabularyManagement,
    readingManagement: enReadingManagement,
    writingDictationManagement: enWritingDictationManagement,
    examManagement: enExamManagement,
    courseLibrary: enCourseLibrary,
    espCourses: enEspCourses,
    liveLearning: enLiveLearning,
    liveCommunication: enLiveCommunication,
    teacher: enTeacher,
    parent: enParent,
    resourcesManagement: enResourcesManagement,
  },
  ar: {
    common: arCommon,
    navigation: arNavigation,
    dashboard: arDashboard,
    errors: arErrors,
    landing: arLanding,
    user: arUser,
    privacySecurity: arPrivacySecurity,
    apiIntegration: arApiIntegration,
    auditLogs: arAuditLogs,
    vocabularyManagement: arVocabularyManagement,
    generalVocabularyManagement: arGeneralVocabularyManagement,
    readingManagement: arReadingManagement,
    writingDictationManagement: arWritingDictationManagement,
    examManagement: arExamManagement,
    courseLibrary: arCourseLibrary,
    espCourses: arEspCourses,
    liveLearning: arLiveLearning,
    liveCommunication: arLiveCommunication,
    teacher: arTeacher,
    parent: arParent,
    resourcesManagement: enResourcesManagement,
  },
  fr: {
    common: frCommon,
    navigation: frNavigation,
    dashboard: frDashboard,
    errors: frErrors,
    landing: frLanding,
    user: frUser,
    privacySecurity: frPrivacySecurity,
    apiIntegration: frApiIntegration,
    auditLogs: frAuditLogs,
    vocabularyManagement: frVocabularyManagement,
    generalVocabularyManagement: frGeneralVocabularyManagement,
    readingManagement: frReadingManagement,
    writingDictationManagement: frWritingDictationManagement,
    examManagement: frExamManagement,
    courseLibrary: frCourseLibrary,
    espCourses: frEspCourses,
    liveLearning: frLiveLearning,
    liveCommunication: frLiveCommunication,
    teacher: frTeacher,
    parent: frParent,
    resourcesManagement: enResourcesManagement,
  },
};

// Get saved language or browser default
// Returns 'en', 'ar', or 'fr'
const getInitialLanguage = () => {
  // Check localStorage first
  const saved = localStorage.getItem('language');
  if (saved === 'en' || saved === 'ar' || saved === 'fr') {
    return saved;
  }
  
  // Check browser language
  const browserLang = navigator.language.split('-')[0];
  if (browserLang === 'ar') {
    return 'ar';
  }
  if (browserLang === 'fr') {
    return 'fr';
  }
  
  // Default to English
  return 'en';
};

const initialLanguage = getInitialLanguage();

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'navigation', 'dashboard', 'errors', 'landing', 'user', 'privacySecurity', 'apiIntegration', 'auditLogs', 'vocabularyManagement', 'generalVocabularyManagement', 'readingManagement', 'writingDictationManagement', 'examManagement', 'courseLibrary', 'espCourses', 'liveLearning', 'liveCommunication', 'teacher', 'parent', 'resourcesManagement'],
    
    // CRITICAL: Arabic plural support (6 forms)
    pluralSeparator: '_',
    compatibilityJSON: 'v4', // Required for proper Arabic plural handling
    
    interpolation: {
      escapeValue: false, // React already escapes
    },
    
    detection: {
      // Order of detection
      order: ['localStorage', 'navigator'],
      // Keys to lookup language from
      lookupLocalStorage: 'language',
      // Cache user language
      caches: ['localStorage'],
      // Detect English, Arabic, and French
      checkWhitelist: true,
    },
    
    // Supported languages: English, Arabic, and French
    supportedLngs: ['en', 'ar', 'fr'],
    nonExplicitSupportedLngs: ['en', 'ar', 'fr'],
    
    react: {
      useSuspense: false, // Disable suspense for better error handling
    },
  });

// Set direction and font when language changes
i18n.on('languageChanged', (lng) => {
  // Allow 'en', 'ar', or 'fr'
  const validLang = (lng === 'en' || lng === 'ar' || lng === 'fr') ? lng : 'en';
  
  if (typeof document !== 'undefined') {
    setDirection(validLang);
    loadFontForLanguage(validLang);
  }
  localStorage.setItem('language', validLang);
  
  logger.log('Language changed to:', validLang);
});

// Initialize direction and font on startup (only if document is available)
if (typeof document !== 'undefined') {
  setDirection(initialLanguage);
  loadFontForLanguage(initialLanguage);
}

export default i18n;

